import styled from 'styled-components';

const StyledIconWrapper = styled.span`
  display: inline-flex;
  width: ${props => props.size || 24}px;
  height: ${props => props.size || 24}px;

  svg {
    width: ${props => props.size || 24}px;
    height: ${props => props.size || 24}px;

    path {
      fill: ${props => props.color || props.theme.colors.neutral_6};
    }
  }
`;


export {
  StyledIconWrapper,
}
